module.exports = "https://r.nearpod.com/assets/media/image/audio-player-delete-btn-d897c585c4f3baad20b0f4b8e56437e0.svg";